import React from 'react';
import {Paper, Skeleton, Stack} from "@mui/material"

function ProjectCardSkeleton() {
    return (
        <Paper variant="outlined" sx={{p: 2.5, borderRadius: 2}}>
            <Stack spacing={2}>
                <Skeleton variant="text" width="60%" height={24}/>
                <Stack direction="row" spacing={1}>
                    <Skeleton variant="rounded" width={80} height={26}/>
                    <Skeleton variant="rounded" width={80} height={26}/>
                </Stack>
            </Stack>
        </Paper>
    );
}

export default ProjectCardSkeleton;
